/* EVANA PADEL - Racheta 3D in sectiunea "Pe scurt" (pagini de rachete).
   Construieste automat un model 3D din poza frontala a produsului:
   fundal eliminat, gauri reale, grosime 38mm, rotire cu mouse/deget. */
(function(){
  var THREE_URL = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  function loadScript(src){ return new Promise(function(res,rej){ if(window.THREE) return res(); var s=document.createElement('script'); s.src=src; s.onload=res; s.onerror=rej; document.head.appendChild(s); }); }
  function loadImg(src){ return new Promise(function(res,rej){ var i=new Image(); i.crossOrigin='anonymous'; i.onload=function(){res(i)}; i.onerror=rej; i.src=src; }); }
  function hasWebGL(){ try{ var c=document.createElement('canvas'); return !!(window.WebGLRenderingContext && (c.getContext('webgl')||c.getContext('experimental-webgl'))); }catch(e){ return false; } }

  function analyse(img, maxH){
    maxH=maxH||900; var sc=Math.min(1, maxH/img.naturalHeight);
    var W=Math.round(img.naturalWidth*sc), H=Math.round(img.naturalHeight*sc);
    var c=document.createElement('canvas'); c.width=W; c.height=H;
    var x=c.getContext('2d'); x.drawImage(img,0,0,W,H);
    var p=x.getImageData(0,0,W,H).data, N=W*H, i, k, xx, yy;
    // culoarea fundalului = mediana pixelilor de pe margini
    var R=[],G=[],B=[];
    function smp(q){ R.push(p[q*4]); G.push(p[q*4+1]); B.push(p[q*4+2]); }
    for(xx=0;xx<W;xx+=3){ smp(xx); smp((H-1)*W+xx); }
    for(yy=0;yy<H;yy+=3){ smp(yy*W); smp(yy*W+W-1); }
    function med(a){ a.sort(function(u,v){return u-v}); return a[a.length>>1]; }
    var br=med(R), bgc=med(G), bb=med(B);
    if(Math.min(br,bgc,bb)<200) return null;
    var white=new Uint8Array(N), tol=10;
    for(i=0;i<N;i++){ if(Math.abs(p[i*4]-br)<=tol && Math.abs(p[i*4+1]-bgc)<=tol && Math.abs(p[i*4+2]-bb)<=tol) white[i]=1; }
    var lab=new Int32Array(N), stack=[];
    function flood(seed,id,val){ stack.length=0; stack.push(seed); lab[seed]=id; var n=0;
      while(stack.length){ var q=stack.pop(); n++; var qx=q%W, qy=(q/W)|0, a;
        if(qx>0){a=q-1; if(white[a]===val&&!lab[a]){lab[a]=id;stack.push(a);}}
        if(qx<W-1){a=q+1; if(white[a]===val&&!lab[a]){lab[a]=id;stack.push(a);}}
        if(qy>0){a=q-W; if(white[a]===val&&!lab[a]){lab[a]=id;stack.push(a);}}
        if(qy<H-1){a=q+W; if(white[a]===val&&!lab[a]){lab[a]=id;stack.push(a);}}
      } return n; }
    for(xx=0;xx<W;xx++){ if(white[xx]&&!lab[xx]) flood(xx,1,1); k=(H-1)*W+xx; if(white[k]&&!lab[k]) flood(k,1,1); }
    for(yy=0;yy<H;yy++){ k=yy*W; if(white[k]&&!lab[k]) flood(k,1,1); k=k+W-1; if(white[k]&&!lab[k]) flood(k,1,1); }
    // cea mai mare zona = racheta
    var id=2, best=0, bestId=0, sizes={};
    for(k=0;k<N;k++){ if(!white[k]&&!lab[k]){ var n=flood(k,id,0); sizes[id]=n; if(n>best){best=n;bestId=id;} id++; } }
    function bbox(){ var b={x0:W,y0:H,x1:0,y1:0}; for(var q=0;q<N;q++){ if(lab[q]===bestId){ var qx=q%W, qy=(q/W)|0; if(qx<b.x0)b.x0=qx; if(qx>b.x1)b.x1=qx; if(qy<b.y0)b.y0=qy; if(qy>b.y1)b.y1=qy; } } return b; }
    var bx=bbox();
    if(bx.x1<=bx.x0||bx.y1<=bx.y0) return null;
    // racheta taiata de marginea pozei (zoom) -> nu o folosim
    if(bx.x0<=1||bx.y0<=1||bx.x1>=W-2||bx.y1>=H-2) return null;
    var bh=bx.y1-bx.y0+1;
    // axa rachetei din partea de sus (capul)
    var hy=bx.y0+Math.round(bh*0.5), hx0=W, hx1=0;
    for(yy=bx.y0;yy<=hy;yy++){ for(xx=bx.x0;xx<=bx.x1;xx++){ if(lab[yy*W+xx]===bestId){ if(xx<hx0)hx0=xx; if(xx>hx1)hx1=xx; } } }
    var xc=(hx0+hx1)/2, hw=hx1-hx0, cut=bx.y0+Math.round(bh*0.70);
    // scoatem snurul/curelusa care atarna langa maner
    for(yy=hy;yy<=bx.y1;yy++){ var lim = yy>cut ? hw*0.2 : hw*0.56;
      for(xx=bx.x0;xx<=bx.x1;xx++){ k=yy*W+xx; if(lab[k]===bestId && Math.abs(xx-xc)>lim) lab[k]=1; } }
    bx=bbox();
    var x0=bx.x0,y0=bx.y0,x1=bx.x1,y1=bx.y1, bw=x1-x0+1; bh=y1-y0+1;
    var holeMax=bw*bh*0.004, holeIds={};
    for(k=0;k<N;k++){ if(white[k]&&!lab[k]){ var n2=flood(k,id,1); if(n2<holeMax) holeIds[id]=1; else sizes[id]=-1; id++; } }
    function solid(si){ var L=lab[si]; if(L===bestId) return true; if(L>1 && sizes[L]===-1) return true; return false; }
    // simetrie stanga-dreapta (cap + gat), pentru alegerea pozei frontale
    var sym=0, tot=0, cy=y0+Math.round(bh*0.70), xm=Math.round((x0+x1)/2), half=Math.round(bw/2);
    for(var y=y0;y<=cy;y+=3){ for(var xo=0;xo<half;xo+=3){ var aL=solid(y*W+xm-xo), aR=solid(y*W+Math.min(W-1,xm+xo)); if(aL||aR){tot++; if(aL===aR) sym++;} } }
    var o=document.createElement('canvas'); o.width=bw; o.height=bh; var ox=o.getContext('2d');
    var od=ox.createImageData(bw,bh), op=od.data, er=0,eg=0,eb=0,en=0;
    for(var y2=0;y2<bh;y2++){ for(var x2=0;x2<bw;x2++){
      var si=(y2+y0)*W+(x2+x0), di=(y2*bw+x2)*4, s=solid(si);
      op[di]=p[si*4]; op[di+1]=p[si*4+1]; op[di+2]=p[si*4+2]; op[di+3]=s?255:0;
      if(s){ var nb=(x2>0&&!solid(si-1))||(x2<bw-1&&!solid(si+1)); if(nb){er+=p[si*4];eg+=p[si*4+1];eb+=p[si*4+2];en++;} }
    } }
    ox.putImageData(od,0,0);
    return {canvas:o, aspect:bw/bh, sym: tot? sym/tot : 0, rim: en?[er/en,eg/en,eb/en]:[60,60,60]};
  }

  function build(el, info){
    var T=window.THREE;
    var w=el.clientWidth||300, h=el.clientHeight||375;
    var renderer=new T.WebGLRenderer({antialias:true, alpha:true});
    renderer.setPixelRatio(Math.min(window.devicePixelRatio||1,2));
    renderer.setSize(w,h); renderer.outputEncoding=T.sRGBEncoding;
    var scene=new T.Scene();
    var cam=new T.PerspectiveCamera(28,w/h,0.1,100);
    var H=4.6, Wd=H*info.aspect, t=0.36;
    cam.position.set(0,0,H*2.3);
    scene.add(new T.AmbientLight(0xffffff,0.75));
    var dl=new T.DirectionalLight(0xffffff,0.7); dl.position.set(3,4,6); scene.add(dl);
    var dl2=new T.DirectionalLight(0xffffff,0.35); dl2.position.set(-4,-2,-5); scene.add(dl2);
    var tex=new T.CanvasTexture(info.canvas); tex.encoding=T.sRGBEncoding; tex.anisotropy=renderer.capabilities.getMaxAnisotropy();
    var g=new T.PlaneGeometry(Wd,H), group=new T.Group();
    var faceMat=new T.MeshStandardMaterial({map:tex, alphaTest:0.5, roughness:0.55, metalness:0.05});
    var front=new T.Mesh(g,faceMat); front.position.z=t/2; group.add(front);
    var back=new T.Mesh(g,faceMat); back.position.z=-t/2; back.rotation.y=Math.PI; group.add(back);
    var rc=info.rim, edgeMat=new T.MeshStandardMaterial({color:new T.Color(rc[0]/255*0.8, rc[1]/255*0.8, rc[2]/255*0.8), alphaMap:tex, alphaTest:0.5, roughness:0.6, side:T.DoubleSide});
    for(var i=1;i<42;i++){ var m=new T.Mesh(g,edgeMat); m.position.z=-t/2 + t*i/42; group.add(m); }
    scene.add(group);
    el.innerHTML=''; el.appendChild(renderer.domElement);
    renderer.domElement.style.cssText='width:100%;height:100%;display:block;cursor:grab;touch-action:pan-y';
    renderer.domElement.setAttribute('aria-label','Model 3D al rachetei - trage pentru a roti');
    var hint=document.createElement('div'); hint.textContent='↻ Trage pentru a roti racheta';
    hint.style.cssText='position:absolute;left:0;right:0;bottom:4px;text-align:center;font:500 11.5px Inter,sans-serif;color:#5F6672;pointer-events:none;transition:opacity .3s';
    el.appendChild(hint);
    var rotY=0.5, rotX=-0.08, vY=0, drag=false, lx=0, ly=0, idle=0, visible=true, clock=0;
    function down(e){ drag=true; var pt=e.touches?e.touches[0]:e; lx=pt.clientX; ly=pt.clientY; renderer.domElement.style.cursor='grabbing'; hint.style.opacity='0'; }
    function move(e){ if(!drag) return; var pt=e.touches?e.touches[0]:e; var dx=pt.clientX-lx, dy=pt.clientY-ly; lx=pt.clientX; ly=pt.clientY; vY=dx*0.012; rotY+=vY; rotX=Math.max(-0.5,Math.min(0.5,rotX+dy*0.006)); idle=0; }
    function up(){ if(drag){ drag=false; renderer.domElement.style.cursor='grab'; } }
    renderer.domElement.addEventListener('mousedown',down); window.addEventListener('mousemove',move); window.addEventListener('mouseup',up);
    renderer.domElement.addEventListener('touchstart',down,{passive:true}); renderer.domElement.addEventListener('touchmove',move,{passive:true}); window.addEventListener('touchend',up);
    if('IntersectionObserver' in window){ new IntersectionObserver(function(en){ visible=en[0].isIntersecting; }).observe(el); }
    window.addEventListener('resize',function(){ var w2=el.clientWidth, h2=el.clientHeight; if(!w2||!h2) return; renderer.setSize(w2,h2); cam.aspect=w2/h2; cam.updateProjectionMatrix(); });
    (function loop(){ requestAnimationFrame(loop); if(!visible) return; clock+=0.016;
      if(!drag){ idle++; vY*=0.94; rotY+=vY; if(idle>90) rotY+=0.009; rotX+=(-0.08-rotX)*0.02; }
      group.rotation.y=rotY; group.rotation.x=rotX; group.position.y=Math.sin(clock*1.2)*0.04;
      renderer.render(scene,cam); })();
  }

  async function init(){
    try{
      if(!/^\/products\//.test(location.pathname)) return;
      var el=document.querySelector('section.ev-hl .hl-img');
      if(!el || !hasWebGL()) return;
      var j=await (await fetch(location.pathname.split('?')[0].replace(/\/$/,'')+'.js')).json();
      var isRacket=(j.type||'').toLowerCase().indexOf('rachet')>-1 || (j.tags||[]).some(function(t){return t.toLowerCase()==='rachete';});
      if(!isRacket || !j.images || !j.images.length) return;
      await loadScript(THREE_URL);
      var best=null;
      for(var i=0;i<Math.min(j.images.length,4);i++){
        try{ var u=j.images[i]; u=(u.indexOf('//')===0?'https:'+u:u); u+= (u.indexOf('?')>-1?'&':'?')+'width=1200';
          var a=analyse(await loadImg(u)); if(a && a.aspect>=0.38 && a.aspect<=0.78 && (!best || a.sym>best.sym+0.02)) best=a; }catch(e){}
      }
      window.__evR3D = best ? {sym:best.sym, aspect:best.aspect} : null;
      if(!best || best.sym<0.85 || best.aspect<0.35 || best.aspect>0.8) return; // fara poza frontala buna -> ramane poza normala
      el.style.position='relative';
      build(el,best);
    }catch(e){ if(window.console) console.warn('ev-racket3d',e); }
  }
  if(document.readyState==='complete') setTimeout(init,300); else window.addEventListener('load',function(){ setTimeout(init,300); });
})();
